import fetchRetry from 'fetch-retry';

// Wrap the global fetch with fetch-retry
export const fetchWithRetry = fetchRetry(globalThis.fetch, {
  retries: 3,        // Default is 3
  retryDelay: 800,  // Default is 800ms
});